import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nombreAbreviado'
})
export class NombreAbreviadoPipe implements PipeTransform {

  transform( name: string, param?: any): string {

    let primerNombre = '';
    let segundoNombre = '';
    let primerApellido = '';
    let segundoApellido = '';

    let result = '';

    if ( name != null ) {
      for (let i = 0; i < name.length; i++) {
        if ( name[i] !== ' ' ) {
          result += name[i];
        } else {
          if ( result !== '' && primerApellido === '' ) {
            primerApellido = result;
            result = '';
          } else if ( result !== '' && segundoApellido === '' ) {
            segundoApellido = result;
            result = '';
          } else if ( result !== '' && primerNombre === '' ) {
            primerNombre = result;
            result = '';
          } else if ( result !== '' && segundoNombre === '' ) {
            segundoNombre = result;
          } else {
            result = '';
          }
        }
      }

      switch (param) {
        case 'pn':
          return primerNombre;
        case 'sn':
          return segundoNombre;
        case 'pa':
          return primerApellido;
        case 'sa':
          return segundoApellido;
        default:
          return '';
      }
    }

  }

}
